import {useEffect, useState} from "react";
import {getCheckHistoryRequest} from "../../../services/api/checks";
import {useParams} from "react-router-dom";
import useSetCheckName from "./useSetCheckName";

const useCheckHistoryData = () => {
  const {id} = useParams();
  useSetCheckName(id);
  const [checkHistoryData, setCheckHistoryData] = useState([]);

  useEffect(() => {
    let cancelled = false;

    getCheckHistoryRequest(id)
      .then(({data}) => !cancelled && setCheckHistoryData(data));

    return () => {
      cancelled = true;
    };
  }, [id]);

  return {
    checkHistory: checkHistoryData.history,
    checkCreator: checkHistoryData.created_by,
    checkCreationDate: checkHistoryData.created_at,
    isProjectAdmin: checkHistoryData.is_user_project_admin,
    checkId: id
  };
};

export default useCheckHistoryData;